import React, { useRef, useState, MouseEvent, useEffect } from 'react';
import Logo from './logo.svg';
import C from './HomePage.css';
import LC from 'components/prelogin-layout/PreLoginLayout.css';
import DoubleChevronDown from '!!react-svg-loader!./double-chevron-down.svg';
import SunriseIcon from './sunrise.svg';
import ClipboardIcon from '!!react-svg-loader!./clipboard.svg';
import WaveVideo from './wave-video.svg';
import LLMBanner from './little-models-video.webm';
import Mic from './mic.svg';
import SparklesIcon from './sparkles.svg';
import formBanner from './formBanner.png';
import SparksIcon from './sparks.svg';
import BulbIcon from './light-bulb.svg';
import LinkIcon from './link-icon.svg';
import WinnerIcon from './winner-icon.svg';
import CocreateIcon from './cocreate-icon.svg';
import LLMIcon from './llm.svg';
import MegaphoneIcon from './megaphone.svg';
import NewsMIT from './news-mit.png';
import NewsEdSurge from './news-edsurge.png';
import NewsTechReview from './news-techreview.png';
import NewsBostonGlobe from './news-bostonglobe.png';
import Testimonials from './Testimonials';
import CircledHeartIcon from './circled-heart.svg';
import VideoEmbed from './VideoEmbed';
import VideoOverlay from './VideoOverlay';
import NoteForm from './NoteForm';
import Header from './Header';
import { introPostUrl, llmPostUrl } from './external-links';
import ROUTES from 'constants/routes';
import PasscodePage from 'components/passcode-page/PasscodePage';
import { smoothScrollTo } from './Header';
import { Trans, msg } from '@lingui/macro';
import LocaleSwitcher from 'components/locale-switcher/LocaleSwitcher';
import { useLingui } from '@lingui/react';
import CloseIcon from '@mui/icons-material/Close';
import cc from 'classnames';
import InviteJoinForm from 'components/invite-join-form/InviteJoinForm';
import { useAuthState } from 'utils/auth-state';
import { useQueryParams } from 'utils/hooks/useQueryParams';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import ModalDialog from 'components/modal-dialog/ModalDialog';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { EVENTS, INTERACTIONS, useTrack } from 'utils/mixpanel';
import Penguins from 'components/server-down/Penguins.png';
import JamDetailsModal from 'components/jam-details-modal/JamDetailsModal';
import { httpClient } from '@cocoplatform/coco-rtc-client';
import PlaySpaceModal from 'components/play-space-modal/PlaySpaceModal';

function WordsForAiComponent({ inIframe }: { inIframe: boolean }) {
  return (
    <Stack
      overflow='hidden'
      sx={{
        height: inIframe ? '100vh' : '100%',
        width: inIframe ? '100vw' : '100%',
      }}
      alignItems='center'
      justifyContent='center'
    >
      <Stack
        alignItems='center'
        justifyContent='center'
        width='100%'
        maxWidth='1000px'
        height='100%'
        p={{
          xs: 2,
          sm: 6,
        }}
      >
        <Box
          sx={{
            width: {
              xs: '100px',
              sm: '150px',
            },
          }}
        >
          <img src={Penguins} width='100%' />
        </Box>
        <Typography
          color='rgb(152, 108, 252)'
          fontWeight='bold'
          textAlign='center'
          variant='h4'
          mt={4}
        >
          Coming Soon!
        </Typography>
        <Typography mt={3} textAlign='center' variant='body1'>
          The visualization will go live on this link:{' '}
          <a href='https://coco.build/wordsforai'>
            https://coco.build/wordsforai
          </a>{' '}
          — once we’ve received over 100 responses — so please feel free to
          share this form with others: <br />
          <a href='https://coco.build/czero'>https://coco.build/czero</a>.<br />
          <br /> We're excited to see what emerges from our collective
          imagination!
        </Typography>
      </Stack>
    </Stack>
  );
}

function GoogleFormComponent({ inIframe }: { inIframe: boolean }) {
  return (
    <Box
      overflow='hidden'
      sx={{
        height: {
          xs: inIframe ? '100vh' : '90vh',
          sm: inIframe ? '100vh' : '90vh',
          md: inIframe ? '100vh' : '80vh',
          lg: inIframe ? '100vh' : '90vh',
        },
      }}
    >
      <iframe
        src='https://docs.google.com/forms/d/e/1FAIpQLScGLniakqWq1L6UV4cMY63ozTnuoteNrIApxKB_rRNGa4HroQ/viewform'
        width='100%'
        height='100%'
        frameBorder='0'
        marginHeight='0'
        marginWidth='0'
        title='CZero Form'
      >
        Loading…
      </iframe>
    </Box>
  );
}

export default function HomePage() {
  const { _ } = useLingui();
  const [showingVideoOverlay, setShowingVideoOverlay] = useState(false);
  const pageContainerRef = useRef<HTMLDivElement>(null);
  const { didSetPasscode, savedToken } = useAuthState();
  const passcodePageVisible = REQUIRE_PASSCODE && !didSetPasscode;

  const passcodeFormVisible = passcodePageVisible;
  const [loading, setLoading] = useState(true);

  const history = useHistory();
  const pageLocation = useLocation();

  const track = useTrack();

  const [showGoogleForm, setShowGoogleForm] = useState(false);
  const [showWordsForAI, setShowWordsForAI] = useState(false);

  const inIframe = window.self !== window.top;

  const { jamId, playCode } = useParams<{ jamId?: string, playCode?: string }>();

  const isPlayPage = window.location.pathname.includes('/play');

  useEffect(() => {
    if (pageLocation.pathname === '/czero') {
      setShowGoogleForm(true);
      track(EVENTS.OPEN_CZERO_FORM, INTERACTIONS.SYSTEM);
    }

    if (pageLocation.pathname === '/wordsforai') {
      setShowWordsForAI(true);
      track(EVENTS.OPEN_WORDS_FOR_AI, INTERACTIONS.SYSTEM);
    }
  }, [pageLocation.pathname]);

  useEffect(() => {
    if (!PAGES_HOME_ENABLED) {
      // Home page is not enabled - take users to landing page
      location.href = ROUTES.LANDING;
      return;
    }
    if (passcodePageVisible || passcodeFormVisible) {
      return;
    }

    // We want to keep the join code link small
    //
    // If join code is present as a hash then redirect to
    // community join page
    const codeMatch = location.hash
      .slice(1)
      .match(/^\/?([a-z0-9]{6})?(\/classroom)?$/i);
    if (codeMatch?.[1]) {
      location.href = `/app/join/${codeMatch[1]}${codeMatch[2] ? '/classroom' : ''}`;
      return;
    }

    const params = new URLSearchParams(window.location.search);

    if (params.has('home')) {
      params.delete('home');
      history.replace({
        search: params.toString(),
      });
    } else if (savedToken) {
      // User is already logged in, redirect to app
      location.href = ROUTES.LANDING;
      return;
    }

    setLoading(false);
  }, [passcodePageVisible, passcodeFormVisible, savedToken]);

  if (passcodePageVisible) {
    return <PasscodePage formVisible={passcodeFormVisible} />;
  }

  if (loading) {
    // Wait to complete initial redirection steps
    return <></>;
  }

  if (showWordsForAI && inIframe) {
    return <WordsForAiComponent inIframe />;
  }

  if (showGoogleForm && inIframe) {
    return <GoogleFormComponent inIframe />;
  }

  return (
    <div
      className={C.pageContainer}
      ref={pageContainerRef}
      id='js-home-page-container'
    >
      {
        isPlayPage && (
          <PlaySpaceModal spaceCode={playCode} onClose={() => {
            history.push('/');
          }} />
        )
      }
      {
        jamId && (
          <JamDetailsModal onClose={() => {
            history.push('/');
          }} onNext={(jamId) => {
            history.push(`/jams/${jamId}`);
          }} onPrev={(jamId) => {
            history.push(`/jams/${jamId}`);
          }} />
        )
      }
      {showGoogleForm && !inIframe && (
        <ModalDialog
          // title={_(msg`CZero Form`)}
          onClose={() => {
            setShowGoogleForm(false);
            history.replace({
              pathname: '/',
            });
          }}
          isCloseable
          fullWidth
          padding={0}
          sx={{
            marginTop: {
              xs: '5rem',
              sm: '5rem',
              md: '5rem',
              lg: '0rem',
            },
            maxWidth: '1500px',
          }}
        >
          <GoogleFormComponent inIframe={false} />
        </ModalDialog>
      )}
      {showWordsForAI && !inIframe && (
        <ModalDialog
          onClose={() => {
            setShowWordsForAI(false);
            history.replace({
              pathname: '/',
            });
          }}
          isCloseable
          fullWidth
          padding={0}
          sx={{
            marginTop: {
              xs: '5rem',
              sm: '5rem',
              md: '5rem',
              lg: '0rem',
            },
            maxWidth: '1500px',
          }}
        >
          <Box
            sx={{
              height: {
                xs: '90vh',
                sm: '90vh',
                md: '80vh',
                lg: '90vh',
              },
            }}
          >
            <WordsForAiComponent inIframe={inIframe} />
          </Box>
        </ModalDialog>
      )}
      {showingVideoOverlay ? (
        <VideoOverlay
          onClose={() => {
            setShowingVideoOverlay(false);
          }}
        />
      ) : null}
      <Header {...{ setShowingVideoOverlay }} />
      <h1 className={C.sitePrimaryTitle}>
        <Trans>CoCo - Being. Creative. Together</Trans>
      </h1>
      <h2 className={C.primaryIntroOuter} style={{ fontSize: 'inherit' }}>
        <span>
          <span className={C.primaryIntroBox}>
            <Trans>
              A calm, collaborative learning platform for young people to engage
              in...
            </Trans>
          </span>
          <span className={C.primaryIntroTagsContainer}>
            <ul className={C.primaryIntroTags}>
              <Trans>
                <li>Being.</li>
                <li>Creative.</li>
                <li>Together.</li>
              </Trans>
            </ul>
          </span>
          <img
            src={WaveVideo}
            className={C.waveVideoIcon}
            alt={_(msg`wave icon`)}
          />
          <img src={Mic} className={C.micIcon} alt={_(msg`mic icon`)} />
        </span>
        <h3 className={C.headingSubtext}>
          <Trans>...in the era of AI</Trans>
        </h3>
      </h2>
      <h3 className={C.secondaryIntro}>
        <Trans>Join creators and educators from 85+ countries!</Trans>
      </h3>
      <div className={C.orgOuter}>
        <InviteJoinForm />
        <div className={C.orgInfoOuter}>
          <div className={C.orgInfo}>
            <Trans>
              Co-imagined and co-created with love and care by a team of{' '}
              <a href='#support' onClick={smoothScrollTo('#support')}>
                <span className={C.teamLink}>MIT PhD Researchers</span>
              </a>
            </Trans>
          </div>
        </div>
      </div>

      <h3
        className={C.bannerHeader}
        style={{
          background: 'var(--col-washed-out-yellow)',
          transform: 'rotate(2deg)',
        }}
        id='coco-demo'
      >
        <a id='coco-intro' />
        <img src={CocreateIcon} className={C.headerIcon} alt='cocreate icon' />
        <Trans>
          Build Multiplayer Games, Stories, Animations, Videos —{' '}
          <span style={{ fontWeight: '900' }}>WITH PEERS IN REAL-TIME!</span>
        </Trans>
      </h3>
      <div className={C.vidPre}>
        <div>
          <Trans>
            See <strong>CoCo</strong> in action
          </Trans>
        </div>
        <div id='video-primary'>
          <DoubleChevronDown className={C.vidDownIcon} />
        </div>
      </div>
      <VideoEmbed />
      {/* AI Education */}
      <div className={C.LLMBannerContainer}>
        <div
          style={{
            color: 'inherit',
            borderRadius: '6px',
          }}
        >
          <h3
            className={cc(C.bannerHeader, C.topBanner)}
            style={{
              background: 'var(--col-washed-out-green)',
              transform: 'rotate(-2deg)',
              marginTop: '35px',
              verticalAlign: 'middle',
            }}
            id='llm-banner'
          >
            <img src={WinnerIcon} className={C.headerIcon} alt='winner icon' />

            <Trans>
              Winners, 2024 Global EdTech Prize for our new AI Education tool
            </Trans>

            <a
              href={llmPostUrl}
              target='_blank'
              rel='noreferrer noopener'
              style={{
                display: 'inline-block',
                padding: '0.2rem 1rem',
                marginLeft: '1rem',
                backgroundColor: '#57DBA0',
                verticalAlign: 'middle',
                color: 'black',
                borderRadius: '6px',
                boxShadow: '1px 1px 4px 3px rgba(0, 0, 0, 0.2)',
              }}
            >
              <span
                style={{
                  verticalAlign: 'middle',
                  fontSize: '1.1rem',
                }}
              >
                <Trans>Read Article</Trans>
              </span>
              <img
                src={LinkIcon}
                className={C.headerIcon}
                style={{
                  margin: '0',
                  marginLeft: '0.7rem',
                  width: '1.1rem',
                  verticalAlign: 'middle',
                }}
                alt='link icon'
              />
            </a>
          </h3>
        </div>
        <div className={C.vidPre}>
          <div>
            <Trans>
              See <strong>Little Language Models</strong> in action
            </Trans>
          </div>
          <div id='video-primary'>
            <DoubleChevronDown className={C.vidDownIcon} />
          </div>
        </div>
        <iframe
          width='675'
          src='https://www.youtube.com/embed/zDHdKREA5og?rel=0'
          title='YouTube video player'
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          referrerPolicy='strict-origin-when-cross-origin'
          allowFullScreen
          className={C.llmBannerImage}
        ></iframe>
      </div>
      <h3
        className={C.bannerHeader}
        style={{
          background: 'var(--col-washed-out-turquoise)',
          transform: 'rotate(2deg)',
        }}
      >
        <img src={SparksIcon} className={C.headerIcon} alt='sparks icon' />
        <Trans>
          Collaborative Coding ~ Math & AI ~ Safe Private Communities ~ No
          Social Media Metrics!
        </Trans>
      </h3>
      <Testimonials />

      <h3
        className={C.bannerHeader}
        style={{
          background: 'var(--col-washed-out-orange)',
          transform: 'rotate(-2deg)',
        }}
        id='motivation-banner'
      >
        <a id='motivations' />
        <img src={BulbIcon} className={C.headerIcon} alt='bulb icon' />
        <Trans>Learn more about the ideas and values underlying CoCo</Trans>
      </h3>
      <div className={C.excerptContainer}>
        <div className={C.excerptContentOuter}>
          <div className={C.excerptContent}>
            <p>
              <Trans>
                We consciously chose to design the CoCo space as a shared
                digital space for co-creating projects in real-time and not
                necessarily for collaborating on the same project in real-time.
              </Trans>
            </p>

            <p>
              <Trans>
                Collaboration often exclusively implies{' '}
                <span style={{ fontStyle: 'italic' }}>working together</span>,
                but a 'shared space' more generally implies{' '}
                <span style={{ fontStyle: 'italic' }}>being together</span> and
                hence is inclusive of collaboration as one of the ways of
                engaging with others but not the only way. There is no denying
                that collaborating with others can be a really joyful,
                productive, and energy-giving experience, but it does not{' '}
                <span style={{ fontStyle: 'italic' }}>always</span> work well
                for <span style={{ fontStyle: 'italic' }}>everyone</span>{' '}
                involved. The reasons can be many--not being able to learn and
                work at your own pace, not feeling comfortable to express
                yourself in the group, feeling or being judged, someone hogging
                the work, perceptions of unfairness in contributions and credit,
                and other negative feelings that can sometimes arise out this
                experience.
              </Trans>
            </p>
          </div>
          <div className={C.excerptGrad} />
        </div>

        <div className={C.excerptCTAContainer}>
          <a
            className={C.excerptCTA}
            href={introPostUrl}
            target='_blank'
            rel='noreferrer noopener'
          >
            <ClipboardIcon />
            <Trans>Read the blog post</Trans>
          </a>
        </div>
      </div>

      <h3
        className={C.bannerHeader}
        style={{
          background: 'var(--col-washed-out-lightgreen)',
          transform: 'rotate(2deg)',
        }}
        id='press-banner'
      >
        <a id='press' />
        <img
          src={MegaphoneIcon}
          className={C.headerIcon}
          alt={_(msg`heart icon`)}
        />
        <Trans>Featured in Boston Globe, MIT Technology Review, MIT News, EdSurge...</Trans>
      </h3>

      <div className={C.pressLink}>
        <div>
          <a
            href='https://www.bostonglobe.com/2025/05/21/opinion/manuj-shruti-dhariwal-mash-c0-ai-interactions/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={NewsBostonGlobe} alt='Boston Globe Article' />
          </a>
        </div>
        <div>
          <a
            href='https://www.technologyreview.com/2024/10/25/1106168/kids-are-learning-how-to-make-their-own-little-language-models/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={NewsTechReview} alt='MIT Technology Review Article' />
          </a>
        </div>
        <div>
          <a
            href='https://news.mit.edu/2023/coco-real-time-co-creative-learning-platform-young-people-0530'
            target='_blank'
            rel='noopener noreferrer'
            style={{ cursor: 'pointer' }}
          >
            <img src={NewsMIT} alt='MIT News Article' />
          </a>
        </div>
        <div>
          <a
            href='https://www.edsurge.com/news/2023-05-09-a-decade-into-experiments-with-gamification-edtech-rethinks-how-to-motivate-learners'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={NewsEdSurge} alt='EdSurge Article' />
          </a>
        </div>
      </div>
      <h3
        className={C.bannerHeader}
        style={{
          background: 'var(--col-washed-out-red)',
          transform: 'rotate(-2deg)',
        }}
      >
        <img
          src={SunriseIcon}
          className={C.headerIcon}
          alt={_(msg`sunrise icon`)}
        />
        <Trans>Want to try CoCo with your community?</Trans>
      </h3>
      <InviteJoinForm />
      <div className={C.inviteDisclaimer}>
        <p>
          <Trans>
            Thank you for your interest—we are excited to share beta invites
            soon!
          </Trans>
        </p>
      </div>
      <h3
        className={C.bannerHeader}
        style={{
          background: 'var(--col-washed-out-pink)',
          transform: 'rotate(2deg)',
        }}
        id='support-banner'
      >
        <a id='support' />
        <img
          src={CircledHeartIcon}
          className={C.headerIcon}
          alt={_(msg`heart icon`)}
        />
        <Trans>Do you resonate with these ideas? We'd love to connect!</Trans>
      </h3>

      <NoteForm />
      <footer className={C.footer}>
        <div>
          <img src={Logo} className={C.footerLogo} alt='coco logo' />
          <div className={C.privacyLinkContainer}>
            <a href='/privacy-terms' className={C.privacyLink}>
              <Trans>Privacy</Trans>
            </a>
            &
            <a href='/terms-of-use' className={C.privacyLink}>
              <Trans>Terms</Trans>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );

  function scrollToTop(e: MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    pageContainerRef.current?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
